<div class="p-2">

    <!-- Title -->
    <div class="row">
      <div class="col-12 h5 text-muted p-0">Sales Data</div>
    </div>
  
    <div class="row bg-light p-2">
      <div class="col-12">
  
        <!-- Filters -->
        <div class="row bg-white pt-2 pb-2">
          <div class="col-12">
            <app-report-filters page="sales-data" [showCalendar]="true" [showCouponSource]="false" [showCouponSourceRetailer]="false" (filterChange)="onfilterChange($event)"></app-report-filters>
          </div>
        </div>
  
        <!-- Sales Data -->
        <div class="row bg-white mt-2 pt-2 pb-2">
          <div class="col-12">
            
            <!-- Loader & Empty message -->
            <div class="row text-center mt-4 mb-4" *ngIf="salesDataCSV.length == 0">
                <div class="col-12">
                    <div class="spinner-border text-info mt-4 mb-4" role="status" *ngIf="salesDataLoading === true"></div>

                    <div class="mt-4 pt-4" *ngIf="salesDataLoading === false && salesDataCSV.length == 0">
                        <i-bs class="text-black-50 mt-4 pt-4" name="clipboardData" width="30" height="30"></i-bs>
                        <div class="col-12 text-center text-black-50 mb-4 pb-4">Data not found</div>
                    </div>
                </div>
            </div>

            <!-- Data Grid -->
            <div class="row" *ngIf="salesDataLoading === false && salesDataCSV.length > 0">
                <div class="col-8">
                    <div class="text-muted mt-3"><span class="fw-bold">{{ totalSales | currency }}</span> from <span class="fw-bold">{{ totalTransaction }}</span> transactions</div>
                </div>
                <div class="col-4">
                    <button type="button" class="btn btn-secondary btn-sm text-white float-end fw-bold mt-2 mb-2" title="Export Sales Data" (click)="generateCSVFile()">
                      <i-bs class="text-light" name="filetypeCsv" width="20" height="20"></i-bs>&nbsp;&nbsp;Export Sales Data
                    </button>
                </div>
                <div class="col-12">
                    <ag-grid-angular
                        style="width: 100%; height: 500px;"
                        class="ag-theme-alpine"
                        [columnDefs]="columnDefs"
                        [defaultColDef]="defaultColDef"
                        [rowData]="salesDataCSV"
                        [rowSelection]="'multiple'"
                        [animateRows]="true">
                    </ag-grid-angular>
                </div>
            </div>

          </div>
        </div>
  
      </div>
    </div>
  
  </div>
  
